var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBranch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 104,
    viewBox: "0 0 57 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4073 93.3673C17.4073 93.3673 -0.303757 80.8965 0.00396394 68.2889C0.334479 54.7124 11.9823 58.0296 15.8231 73.5326C17.4068 80.0171 17.9416 86.7135 17.4073 93.3673Z",
    fill: "#D7DEE2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8275 36.0404C32.8275 36.0404 43.7117 17.3 38.1499 5.95768C32.1779 -6.23954 22.969 1.64876 25.9664 17.357C27.2387 23.912 29.5552 30.2201 32.8275 36.0404Z",
    fill: "#D7DEE2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.899 16.8782C33.899 15.7382 32.0185 15.8864 32.0641 17.0605C32.4156 24.9718 32.2938 32.897 31.6994 40.7938C30.6957 53.8253 27.8603 66.6503 23.277 78.8902C20.0762 87.27 16.2433 95.3945 11.8115 103.193H13.9086C15.1395 100.971 16.3475 98.7363 17.4986 96.4792C23.783 84.3517 28.3843 71.4236 31.1751 58.0523C33.7045 44.4832 34.6188 30.6623 33.899 16.8782Z",
    fill: "#C3D0D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9551 59.3176C29.9551 59.3176 50.9713 54.0512 55.2224 42.1503C59.7812 29.3604 47.7231 28.266 38.5598 41.3638C34.7463 46.8474 31.8408 52.9097 29.9551 59.3176Z",
    fill: "#D7DEE2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1826 72.5637C26.1826 72.5637 8.47163 60.1043 8.77935 47.4853C9.10987 33.9087 20.769 37.226 24.6098 52.7404C26.1933 59.2211 26.7244 65.9143 26.1826 72.5637Z",
    fill: "#D7DEE2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7949 85.593C21.7949 85.593 43.4493 85.9121 50.6295 75.5046C58.3339 64.3219 46.9482 60.1612 34.7306 70.4547C29.6346 74.774 25.2669 79.8854 21.7949 85.593Z",
    fill: "#D7DEE2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBranch);
export default __webpack_public_path__ + "static/media/branch.e1a3167e2752149b528b51efc5f62414.svg";
export { ForwardRef as ReactComponent };